var _path, _path2, _line;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCapitalInvested(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9885 15.225C9.45385 14.8479 7.31856 13.4596 5.93121 9.0756C5.72718 8.43088 6.24961 7.79741 6.92262 7.86343C11.5335 8.31579 13.7082 9.70391 14.9698 14.0365C15.154 14.6688 14.6449 15.2796 13.9885 15.225Z",
    stroke: "#0EF1BC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8552 20.225C22.3899 19.8479 24.5252 18.4596 25.9125 14.0756C26.1166 13.4309 25.5941 12.7974 24.9211 12.8634C20.3103 13.3158 18.1355 14.7039 16.8739 19.0365C16.6898 19.6688 17.1989 20.2796 17.8552 20.225Z",
    stroke: "#68F4C9",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 8,
    x2: 16,
    y2: 24,
    stroke: "#0BC196",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapitalInvested);
export default __webpack_public_path__ + "static/media/capitalInvested.35bedd46115eb228ba467ef73a0df9f1.svg";
export { ForwardRef as ReactComponent };